<div class="container">
  <mat-card style="margin-top: 50px">
    <mat-card-content style="margin-left: auto; margin-right: auto">
      <ng-container *ngIf="loadingData">
        <div class="row">
          <div class="col-md-2"></div>
          <div class="col-md-8">
            <i class="fas fa-spinner fa-pulse"></i> Loading Subscriptions,
            Please Wait...
          </div>
          <div class="col-md-2"></div>
        </div>
      </ng-container>
      <ng-container *ngIf="!loadingData">
        <div class="row">
          <div class="col-md-1"></div>
          <div class="col-md-10">
            <h1 class="mt-5">My Subscriptions</h1>
          </div>
          <div class="col-md-1"></div>
        </div>
        <ng-container *ngFor="let sub of userSubscriptions; let currentIndex = index">
          <div class="row" style="padding-bottom: 15px">
            <div class="col-md-1"></div>
            <div class="col-md-10">
              <mat-card style="background-color: rgb(220, 220, 220);" class="subscriptionList">
                <mat-card-content>
                  <table class="table-fix">
                    <tr>
                      <td>
                        <a href="#"
                           (click)="loadSubscriptionDetails(sub.subscriptionId)">#{{ currentIndex + 1 }} {{ sub.subscriptionName }}</a>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <ng-container *ngIf="
                            sub.xmlaEndPoint !== null && sub.xmlaEndPoint !== ''
                          ">
                          Subscription Type: Analytical Dataset
                        </ng-container>
                        <ng-container *ngIf="
                            sub.apiSubscriptionToken !== null && sub.apiSubscriptionToken !== ''
                          ">
                          Subscription Type: Interactive / API
                        </ng-container>
                        <ng-container *ngIf="sub.isReportSubscription">
                          Subscription Type: Report
                        </ng-container>
                        <ng-container *ngIf="
                            (sub.xmlaEndPoint === null || sub.xmlaEndPoint === '') && (sub.apiSubscriptionToken === null || sub.apiSubscriptionToken === '') && !sub.isReportSubscription
                          ">
                          Subscription Type: Interactive
                        </ng-container>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Expires:
                        <strong>
                          {{
                          sub.expirationDate | date: "fullDate"
                          }}
                        </strong>
                      </td>
                    </tr>
                    <tr *ngIf="sub.allowActivateAutoRenew">
                      <td>
                        <a href="#"
                           (click)="activateAutoRenew(sub.subscriptionId)">Activate Auto Renew</a>
                      </td>
                    </tr>
                    <tr *ngIf="sub.allowCancelAutoRenew">
                      <td>
                        <a href="#"
                           (click)="cancelAutoRenew(sub.subscriptionId)">Cancel Auto Renew</a>
                      </td>
                    </tr>
                    <tr *ngIf="sub.allowUpdateAutoRenew">
                      <td>
                        <a href="#"
                           (click)="updateAutoRenew(sub.subscriptionId)">Update Auto Renew</a>
                      </td>
                    </tr>
                    <tr *ngIf="sub.allowRenew">
                      <td>
                        <a href="#"
                           (click)="renewSubscription(sub.subscriptionId)">Renew Subscription</a>
                      </td>
                    </tr>
                  </table>
                </mat-card-content>
              </mat-card>
            </div>
            <div class="col-md-1"></div>
          </div>
        </ng-container>
      </ng-container>
    </mat-card-content>
  </mat-card>
</div>
